import { render, staticRenderFns } from "./OpportunityList.vue?vue&type=template&id=6f4ef55c&scoped=true"
import script from "./OpportunityList.vue?vue&type=script&lang=js"
export * from "./OpportunityList.vue?vue&type=script&lang=js"
import style0 from "./OpportunityList.vue?vue&type=style&index=0&id=6f4ef55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ef55c",
  null
  
)

export default component.exports